"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Dialog2 = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _Typography2 = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Skeleton2 = _interopRequireDefault(require("@material-ui/lab/Skeleton"));

var _Tooltip2 = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _IconButton2 = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _DeleteRounded2 = _interopRequireDefault(require("@material-ui/icons/DeleteRounded"));

var _styles = require("@material-ui/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var React = _interopRequireWildcard(require("react"));

var _FieldInput = _interopRequireDefault(require("../components/FieldInput"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    title: {
      fontWeight: 600,
      fontSize: 20,
      marginBottom: -20,
      marginTop: -10
    },
    labelWrapper: {
      marginBottom: 6,
      "& svg": {
        fontSize: 16,
        marginRight: 6,
        color: theme.palette.text.secondary
      }
    },
    deleteButton: {
      position: "absolute",
      right: 26,
      top: 24
    }
  };
});

var DialogRecord = function DialogRecord(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      record = _ref.record,
      fields = _ref.fields,
      onChange = _ref.onChange,
      onOpenInput = _ref.onOpenInput,
      isLoading = _ref.isLoading,
      onClickDelete = _ref.onClickDelete;
  var classes = useStyles();

  var _React$useState = React.useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      data = _React$useState2[0],
      setData = _React$useState2[1];

  React.useEffect(function () {
    if (record) {
      setData(record);
    }
  }, [record]);
  var title = data.name || "Unnamed";

  var handleChange = function handleChange(name, value) {
    var newData = _objectSpread(_objectSpread({}, data), {}, _defineProperty({}, name, value));

    setData(newData);
    onChange === null || onChange === void 0 ? void 0 : onChange(newData);
  };

  return /*#__PURE__*/React.createElement(_Dialog2["default"], {
    scroll: "body",
    fullWidth: true,
    open: open,
    onClose: onClose,
    maxWidth: "sm"
  }, /*#__PURE__*/React.createElement(_Tooltip2["default"], {
    title: "Delete"
  }, /*#__PURE__*/React.createElement(_IconButton2["default"], {
    onClick: onClickDelete,
    className: classes.deleteButton,
    size: "small"
  }, /*#__PURE__*/React.createElement(_DeleteRounded2["default"], {
    fontSize: "small"
  }))), /*#__PURE__*/React.createElement(_Box2["default"], {
    m: 4,
    pb: 2
  }, /*#__PURE__*/React.createElement(_Typography2["default"], {
    className: classes.title,
    variant: "subtitle1"
  }, isLoading ? /*#__PURE__*/React.createElement(_Skeleton2["default"], {
    width: 200
  }) : title), fields === null || fields === void 0 ? void 0 : fields.map(function (item) {
    var type = item.type,
        name = item.name;
    var value = data[name];
    var disabled = ["count", "formula", "autoNumber", "createdAt", "updatedAt", "createdBy", "updatedBy", "lookup"].includes(type);
    return /*#__PURE__*/React.createElement(_Box2["default"], {
      key: item.id,
      mt: 4
    }, /*#__PURE__*/React.createElement(_FieldInput["default"], {
      disabled: disabled,
      field: item,
      onChange: handleChange,
      onOpenInput: onOpenInput,
      value: value
    }));
  })));
};

DialogRecord.propTypes = {
  isLoading: _propTypes["default"].bool,
  open: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onClickDelete: _propTypes["default"].func,
  onOpenInput: _propTypes["default"].func,
  record: _propTypes["default"].object,
  fields: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    name: _propTypes["default"].string,
    type: _propTypes["default"].string,
    options: _propTypes["default"].object
  }))
};
var _default = DialogRecord;
exports["default"] = _default;